module.exports = __webpack_public_path__ + "static/media/rui_liang_xu.2a7608dc.jpg";